import { freshSheetArrayFactoryCore } from './chunk-V5Q7S5H3.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/menu/freshSheetScreen.ts
var freshSheetItemsFactoryCore = (items, state) => {
  return freshSheetArrayFactoryCore(items, state).reduce((acc, item) => {
    return __spreadProps(__spreadValues({}, acc), { [item.id]: item });
  }, {});
};

export { freshSheetItemsFactoryCore };
